/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type AuditLogFacetOption = {
  /**
   * The number of audit logs for this facet value
   */
  count: number;
  /**
   * The display label shown for the facet value
   */
  displayName: string;
  /**
   * The facet value used for filtering
   */
  value: string;
};

/** @internal */
export const AuditLogFacetOption$inboundSchema: z.ZodMiniType<
  AuditLogFacetOption,
  unknown
> = z.pipe(
  z.object({
    count: z.int(),
    display_name: z.string(),
    value: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "display_name": "displayName",
    });
  }),
);

export function auditLogFacetOptionFromJSON(
  jsonString: string,
): SafeParseResult<AuditLogFacetOption, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AuditLogFacetOption$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AuditLogFacetOption' from JSON`,
  );
}
